export type Scene = {
  key: string;
  date: string;
  panchromatic: File,
  multiSpectral: File
}

export enum UploadStatus {
  Uploading = 1,
  Error,
  Success
}

export type TUploadStatus = {
  sceneId: string;
  scene: Scene;
  uploadController: AbortController;
  multiSpectral: UploadStatus;
  panchromatic: UploadStatus;
}

export type TSceneUploadStatus = {
  [key: string]: TUploadStatus
}

